import React, { useEffect, useState } from "react";
import "../css/customerInfo.css";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { getFormatedAddress } from "../helpers/_invoiceHelpers";
import { useAtom } from "jotai";
import { tempIPDPatientDetailsAtom } from "../constants/_constant";

const CustomerInfo = ({ customerInfo, patientInfo, isInstitutionPatient }) => {
  const [uhid, setUhid] = useState("");
  const [address, setAddress] = useState("");
  const [age, setAge] = useState("");
  const [payMode, setPayMode] = useState("Credit"); // Default set to Credit
  const [inchargeDoctor, setInchargeDoctor] = useState("");
  const [tpa, setTpa] = useState("");
  const [insuranceCompany, setInsuranceCompany] = useState("");
  const [tempIPDPatientInfo, settempIPDPatientInfo] = useAtom(
    tempIPDPatientDetailsAtom
  );

  console.log("Patient Info", patientInfo);

  useEffect(() => {
    settempIPDPatientInfo({
      gender: patientInfo?.gender,
      dob: patientInfo?.dob,
      age: age,
      address: address,
      uhid,
      payMode, // add pay mode to temp IPD patient details
      inchargeDoctor, // added incharge doctor to the atom
      tpa,
      insuranceCompany,
    });
  }, [
    patientInfo,
    address,
    uhid,
    payMode,
    inchargeDoctor,
    age,
    tpa,
    insuranceCompany,
    settempIPDPatientInfo,
  ]);

  const handleSave = () => {
    // You can add your save logic here.
    console.log(
      "UHID:",
      uhid,
      "Address:",
      address,
      "Pay Mode:",
      payMode,
      "Incharge DR:",
      inchargeDoctor,
      "TPA:",
      tpa,
      "Insurance Company:",
      insuranceCompany
    );
  };

  return (
    <div className="cu-customer-info-main">
      <div className="cu-general-info-heading">
        <span>
          <img
            src={cufrontIcons.customer}
            alt=""
            width={"22.59px"}
            height={"24px"}
          />
        </span>
        <span className="cu-create-invoice-heading-text">
          {isInstitutionPatient ? "Customer Info" : "Patient Info"}
        </span>
      </div>
      {isInstitutionPatient && (
        <div className="cu-customer-info-cont">
          <div className="cu-customer-info-div">
            <div>Contact Person Name:</div>
            <div style={{ fontWeight: "bold" }}>
              {customerInfo?.contact_person_name || "-"}
            </div>
          </div>
          <div className="cu-customer-info-div">
            <div>Contact Person Mobile Number:</div>
            <div style={{ fontWeight: "bold" }}>
              {customerInfo?.contact_number || "-"}
            </div>
          </div>
          <div className="cu-customer-info-div">
            <div>Billing Address:</div>
            <div style={{ fontWeight: "bold" }}>
              {getFormatedAddress(customerInfo?.billing_address)}
            </div>
          </div>
        </div>
      )}
      {!isInstitutionPatient && (
        <div className="cu-customer-info-cont">
          <div className="cu-customer-info-div">
            <div>Name:</div>
            <div style={{ fontWeight: "bold" }}>
              {patientInfo?.full_name || "-"}
            </div>
          </div>
          <div className="cu-customer-info-div">
            <div>Age:</div>
            <div style={{ fontWeight: "bold" }}>{patientInfo?.age || "-"}</div>
          </div>
          <div className="cu-customer-info-div">
            <div>Gender:</div>
            <div style={{ fontWeight: "bold" }}>
              {patientInfo?.gender || "-"}
            </div>
          </div>
        </div>
      )}

      {/* New Input Fields with Tailwind CSS */}
      <div className="cu-customer-info-cont">
        {patientInfo.dob || (
          <div className="cu-customer-info-div">
            <label htmlFor="ageInput">Age:</label>
            <input
              id="ageInput"
              type="text"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              placeholder="Enter Age"
              className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}
        <div className="cu-customer-info-div">
          <label htmlFor="uhidInput">UHID:</label>
          <input
            id="uhidInput"
            type="text"
            value={uhid}
            onChange={(e) => setUhid(e.target.value)}
            placeholder="Enter UHID"
            className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="cu-customer-info-div">
          <label htmlFor="addressInput">Address:</label>
          <input
            id="addressInput"
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter Address"
            className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="cu-customer-info-div">
          <label htmlFor="inchargeDR">Incharge DR:</label>
          <input
            id="inchargeDR"
            type="text"
            value={inchargeDoctor}
            onChange={(e) => setInchargeDoctor(e.target.value)}
            placeholder="Enter Incharge DR"
            className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Additional Fields for TPA and Insurance Company */}
      <div className="cu-customer-info-cont">
        <div className="cu-customer-info-div">
          <label htmlFor="tpaInput">TPA:</label>
          <input
            id="tpaInput"
            type="text"
            value={tpa}
            onChange={(e) => setTpa(e.target.value)}
            placeholder="Enter TPA"
            className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="cu-customer-info-div">
          <label htmlFor="insuranceCompanyInput">Insurance Company:</label>
          <input
            id="insuranceCompanyInput"
            type="text"
            value={insuranceCompany}
            onChange={(e) => setInsuranceCompany(e.target.value)}
            placeholder="Enter Insurance Company"
            className="mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Pay Mode Dropdown with Enhanced UI */}
      <div className="cu-customer-info-cont">
        <div className="cu-customer-info-div relative">
          <label htmlFor="payModeDropdown">Pay Mode:</label>
          <select
            id="payModeDropdown"
            value={payMode}
            onChange={(e) => setPayMode(e.target.value)}
            className="mt-1 p-2 pr-8 border border-gray-300 rounded bg-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="Cash">Cash</option>
            <option value="Credit">Credit</option>
            <option value="Debit">Debit</option>
            {/* Add more options if needed */}
          </select>
          {/* Custom arrow icon */}
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <svg
              className="w-4 h-4 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Save Button with Tailwind CSS */}
      {/* <div className="cu-customer-info-cont" style={{ marginTop: "20px" }}>
        <button
          className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded shadow"
          onClick={handleSave}
        >
          Save
        </button>
      </div> */}
    </div>
  );
};

export default CustomerInfo;
